module.exports = __webpack_public_path__ + "img/aim.75545bd4.svg";